export let router;
export let renderer;

export function init(opts) {
	router = opts.router;
	renderer = opts.renderer;
}
